import { Reveal } from "../Reveal";
import { Chapter } from "../Chapter";

const MOMENTS = [
  {
    t: "They’ve sent you a message and you’re furious.",
    d: "Before replying, let’s work out what they’re actually saying — and what response gets you closer to the outcome you want.",
  },
  {
    t: "You’re thinking about making a big move.",
    d: "Calling their parents. Contacting a solicitor. Sending the long message. Drawing a line in the sand. Before you do it, let’s stress-test it.",
  },
  {
    t: "You can’t tell whether you’re being reasonable anymore.",
    d: "Sometimes you need somebody outside the situation who isn’t automatically going to tell you you’re right.",
  },
  {
    t: "You’re trying to solve everything tonight.",
    d: "We bring the horizon closer. What actually needs dealing with today?",
  },
];

export const BeforeYouSend = () => (
  <section className="bg-paper2" data-testid="before-you-send-section">
    <div className="mx-auto max-w-6xl px-5 md:px-8 py-20 md:py-28">
      <Chapter
        n={3}
        kicker="In practice"
        title="Sometimes it’s the next 20 minutes that matter."
      />
      <div className="max-w-3xl">
        {MOMENTS.map((m, i) => (
          <Reveal key={m.t} delay={i * 0.06}>
            <div
              className="border-t border-ink/10 py-8 md:py-9 last:border-b"
              data-testid={`moment-${i}`}
            >
              <h3 className="font-serif text-2xl md:text-3xl tracking-tight leading-snug text-ink">
                {m.t}
              </h3>
              <p className="mt-3 max-w-xl text-base md:text-lg leading-relaxed text-ink/65">
                {m.d}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
